import React from 'react';
import {
  Backdrop,
  Paper,
  DialogActions,
  Button,
  Divider,
} from '@material-ui/core';

export function EeConfirmDialog(props: any) {
  const {
    open,
    onCancel,
    onConfirm,
    children,
    cancelButtonLabel,
    confirmButtonLabel,
  } = props;
  if (!open) return null;
  return (
    <>
      <Backdrop
        style={{ position: 'absolute', zIndex: 1 }}
        open={open}
        // onClick={onClose} // Causing the dialog to close no matter where you click
      >
        <Paper
          variant="outlined"
          style={{ borderLeft: '6px solid var(--color-red)' }}
        >
          <div className="d-flex align-items-center py-3">
            <div className="p-3">
              <i
                className="material-icons"
                style={{ color: 'var(--color-red)' }}
              >
                remove_circle
              </i>
            </div>
            <div className="pr-3">{children}</div>
          </div>
          <Divider />
          <DialogActions>
            <Button onClick={onCancel} color="primary">
              {cancelButtonLabel || 'Cancel'}
            </Button>
            <Button onClick={onConfirm} color="primary" autoFocus>
              {confirmButtonLabel || 'Confirm'}
            </Button>
          </DialogActions>
        </Paper>
      </Backdrop>
    </>
  );
}
